import DateFormat from '@/lib/Dates/DateFormat';
import momentFilter from '@/filters/moment';

/**
 * Display a Date object as a formatted string, where the time is the most important
 * thing to display: 1:23 PM
 * If the second parameter is true it also adds the date: Jan 25th 1:23 PM
 * If the third parameter is true it adds the date and seconds: Mon Nov 18th 2024 11:54:51 AM
 *
 * See DateFormat.js for more info about the difference between dateFilter and timeFilter.
 *
 * @param {Date} date
 * @param {boolean} withDate
 * @param {boolean} withDateAndSeconds
 *
 * @return {string}
 */
export const timeFilter = (date, withDate, withDateAndSeconds) => {
    if (withDateAndSeconds) {
        // Date + Time + Seconds: Jan 25th 1:23:45 PM
        return momentFilter(date, DateFormat.TIME_WITH_DATE_WITH_SECS);
    }

    if (withDate) {
        // Date + Time: Jan 25th 1:23 PM
        return momentFilter(date, DateFormat.TIME_WITH_DATE);
    }

    // Time only: 1:23 PM
    return momentFilter(date, DateFormat.TIME);
};
